const initialState = {
   balance: {},
   stats: {},
   payouts: [],
   transactions: [],
   payoutMethods: [],
   settings: {},
   activeTab: 0,
   isLoading: true,
   isWithdrawing: false,
   isSavingSettings: false,
   isConnectingStripe: false,
   isLinkingBankAccount: false,
   stripeConnect: {},
};

export default initialState;
